import { render, staticRenderFns } from "./MainHeaderSearchBtn.vue?vue&type=template&id=1bd8a898"
import script from "./MainHeaderSearchBtn.vue?vue&type=script&lang=js"
export * from "./MainHeaderSearchBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports